/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

import type { PhoneCode } from "@spwn/types/gmo";

type Props = {
  isDarkModeEnabled: boolean;
  phoneCode: PhoneCode | null;
  setPhoneCode: (code: PhoneCode | null) => void;
};

export const StreamingLiveCommerceCareerPaymentV2: React.FC<Props> = (
  props
) => {
  const { t } = useI18n();
  const classesCareerPaymentDesign = careerPaymentDesign({
    isDarkModeEnabled: props.isDarkModeEnabled,
  });

  return (
    <React.Fragment>
      <div css={classesCareerPaymentDesign.container}>
        <div css={classesCareerPaymentDesign.cautionTextGroup}>
          <p css={classesCareerPaymentDesign.cautionTextFirst}>
            {t("streaming.commerceCareerPayment.cautions.first")}
          </p>
          <div>
            <p css={classesCareerPaymentDesign.cautionTextSecond}>
              {t("streaming.commerceCareerPayment.cautions.second", {
                hour: 1,
              })}
            </p>
            <p css={classesCareerPaymentDesign.cautionTextThird}>
              {t("streaming.commerceCareerPayment.cautions.third")}
            </p>
          </div>
        </div>
        <div css={classesCareerPaymentDesign.radioInputContainer}>
          <div css={classesCareerPaymentDesign.selectionBox}>
            <input
              type="radio"
              id="csv-10001"
              name="cardSelection"
              css={classesCareerPaymentDesign.radioInput}
              onChange={() => props.setPhoneCode("docomo")}
              checked={props.phoneCode === "docomo"}
            />
            <label
              htmlFor="csv-10001"
              css={classesCareerPaymentDesign.radioLabel}
            >
              {t("streaming.commerceCareerPayment.phoneInfo.docomo")}
            </label>
          </div>
          <div css={classesCareerPaymentDesign.selectionBox}>
            <input
              type="radio"
              id="csv-10002"
              name="cardSelection"
              css={classesCareerPaymentDesign.radioInput}
              onChange={() => props.setPhoneCode("au")}
              checked={props.phoneCode === "au"}
            />
            <label
              htmlFor="csv-10002"
              css={classesCareerPaymentDesign.radioLabel}
            >
              {t("streaming.commerceCareerPayment.phoneInfo.au")}
            </label>
          </div>
          <div css={classesCareerPaymentDesign.selectionBox}>
            <input
              type="radio"
              id="csv-10008"
              name="cardSelection"
              css={classesCareerPaymentDesign.radioInput}
              onChange={() => props.setPhoneCode("sb")}
              checked={props.phoneCode === "sb"}
            />
            <label
              htmlFor="csv-10008"
              css={classesCareerPaymentDesign.radioLabel}
            >
              {t("streaming.commerceCareerPayment.phoneInfo.sb")}
            </label>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

type CareerPaymentStylesProps = {
  isDarkModeEnabled: boolean;
};

const careerPaymentDesign = (props: CareerPaymentStylesProps) => {
  const theme = {
    text: props.isDarkModeEnabled ? "#FFFFFF" : "#000000",
    bg: props.isDarkModeEnabled ? "#000000" : "#FFFFFF",
    inputBg: props.isDarkModeEnabled ? "#1A1A1A" : "#F0F0F0",
    border: props.isDarkModeEnabled ? "#FFFFFF" : "#000000",
  };

  const container = css`
    margin: 0 16px 0 16px;
    padding-bottom: 16px;
    border-top: 1px solid ${theme.border};
  `;
  const selectionBox = css``;
  const radioInputContainer = css`
    padding-left: 16px;
  `;
  const radioInput = css`
    display: none;
    &:checked + label::before {
      background-color: ${theme.text};
    }
    &:checked + label::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 29px;
      transform: translateY(-50%);
      width: 6px;
      height: 6px;
      background-color: ${theme.bg};
      border-radius: 50%;
    }
  `;
  const radioLabel = css`
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 16px 0 16px 56px;
    color: ${theme.text};
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-sizing: border-box;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      border: 2px solid ${theme.border};
      border-radius: 50%;
      box-sizing: border-box;
    }
  `;
  const textInputContainer = css`
    padding: 0 24px 0 24px;
  `;

  const cautionTextFirst = css`
    color: ${theme.text};
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  `;

  const cautionTextSecond = css`
    color: ${theme.text};
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  `;

  const cautionTextThird = css`
    color: #e53e3e;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
  `;

  const cautionTextGroup = css`
    display: flex;
    flex-direction: column;
    margin: 16px 0;
    gap: 16px;
  `;

  return {
    container,
    selectionBox,
    radioInputContainer,
    radioInput,
    radioLabel,
    textInputContainer,
    cautionTextFirst,
    cautionTextSecond,
    cautionTextThird,
    cautionTextGroup,
  };
};
